/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_AccountsInputs */

const th_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีสำหรับนักพัฒนา`)
};

const en_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dev accounts`)
};

const ja_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用アカウント`)
};

const zh_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发账户`)
};

const es_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuentas de desarrollo`)
};

const pt_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contas de desenvolvimento`)
};

const id_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun pengembangan`)
};

const fr_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptes de développement`)
};

const tl_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga development account`)
};

const vi_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản phát triển`)
};

const ko_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개발용 계정`)
};

const de_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklungskonten`)
};

const ru_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунты для разработки`)
};

const tr_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirme hesapları`)
};

const it_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account di sviluppo`)
};

const pl_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konta deweloperskie`)
};

const uk_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облікові записи для розробки`)
};

const hi_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपमेंट खाते`)
};

const ar_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حسابات التطوير`)
};

const ms_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun pembangunan`)
};

const bn_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেভেলপমেন্ট অ্যাকাউন্ট`)
};

const zh_tw2_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開發帳戶`)
};

const zh_hk2_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開發帳戶`)
};

const ur_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ڈویلپمنٹ اکاؤنٹس`)
};

const fa_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب‌های توسعه`)
};

const sw_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti za uendelezaji`)
};

const nl_dev_accounts = /** @type {(inputs: Dev_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontwikkelaccounts`)
};

/**
* | output |
* | --- |
* | "Dev accounts" |
*
* @param {Dev_AccountsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const dev_accounts = /** @type {((inputs?: Dev_AccountsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_AccountsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_dev_accounts(inputs)
	if (locale === "ja") return ja_dev_accounts(inputs)
	if (locale === "zh") return zh_dev_accounts(inputs)
	if (locale === "es") return es_dev_accounts(inputs)
	if (locale === "pt") return pt_dev_accounts(inputs)
	if (locale === "id") return id_dev_accounts(inputs)
	if (locale === "fr") return fr_dev_accounts(inputs)
	if (locale === "tl") return tl_dev_accounts(inputs)
	if (locale === "vi") return vi_dev_accounts(inputs)
	if (locale === "ko") return ko_dev_accounts(inputs)
	if (locale === "de") return de_dev_accounts(inputs)
	if (locale === "ru") return ru_dev_accounts(inputs)
	if (locale === "tr") return tr_dev_accounts(inputs)
	if (locale === "it") return it_dev_accounts(inputs)
	if (locale === "pl") return pl_dev_accounts(inputs)
	if (locale === "uk") return uk_dev_accounts(inputs)
	if (locale === "hi") return hi_dev_accounts(inputs)
	if (locale === "ar") return ar_dev_accounts(inputs)
	if (locale === "ms") return ms_dev_accounts(inputs)
	if (locale === "bn") return bn_dev_accounts(inputs)
	if (locale === "zh-TW") return zh_tw2_dev_accounts(inputs)
	if (locale === "zh-HK") return zh_hk2_dev_accounts(inputs)
	if (locale === "ur") return ur_dev_accounts(inputs)
	if (locale === "fa") return fa_dev_accounts(inputs)
	if (locale === "sw") return sw_dev_accounts(inputs)
	if (locale === "nl") return nl_dev_accounts(inputs)
	return en_dev_accounts(inputs)
});